// Lazy-loaded PDF generator to reduce initial bundle size
// Only load jsPDF when actually needed (94KB savings on initial load)

let pdfGeneratorModule: any = null;

export const loadPdfGenerator = async () => {
  if (!pdfGeneratorModule) {
    pdfGeneratorModule = await import('./pdfGenerator');
  }
  return pdfGeneratorModule;
};

export const generateQuotePDF = async (data: any) => {
  const module = await loadPdfGenerator();
  return module.generateQuotePDF(data);
};

export const generateBrochure = async (
  language: 'en' | 'ar',
  options?: { output?: 'save' | 'blob' }
) => {
  const module = await loadPdfGenerator();
  return module.generateBrochure(language, options);
};
